<div *nzModalTitle>
  <h4 class="mb-0">Notifications</h4>
</div>

<app-notification-data-card-items
  [notifications]="notifications"
  [isLoading]="isLoading"></app-notification-data-card-items>

<div *nzModalFooter>
  <button type="button" class="btn btn-outline-danger" (click)="cancel()">Close</button>
</div>
